export default "__VITE_ASSET__DQMNy1OD__"